// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","content":"Button_content__JvV2b","content_primary":"Button_content_primary__zlNMx"};